// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.generic-editor__tooltip-lock{font-weight:normal}.generic-editor__tooltip-lock .tooltip-content{left:-24px}.generic-editor__tooltip-lock-content{width:210px}`, "",{"version":3,"sources":["webpack://./src/components/InlineEditor/GenericEditor/style.scss"],"names":[],"mappings":"AAEE,8BACE,kBAAA,CAEA,+CACE,UAAA,CAGF,sCACE,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
